import { MeltshopHeats } from "./MeltshopHeats";

const MeltshopHeatsIndex = () => {
  return <MeltshopHeats />;
};

export default MeltshopHeatsIndex;
